import styled from '@emotion/styled'
import { Upload } from 'lucide-react'
import Typography from 'components/core/Typography'
import { DESIGN_TOKENS } from 'constants/color.constants'
import { SPACING } from 'constants/spacing.constants'

import Row from 'components/core/Row'
import Column from 'components/core/Column'
import { GLOBAL_Z_INDEXES } from 'constants/app.constants'

const DROPZONE_BG_COLOR = 'rgba(255, 255, 255, 0.8)'

const StyledFileDropzoneOverlay = styled(Row)`
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    /**
    * @NOTE: this overlay must be rendered within a parent that has "position: relative"
    */
    position: absolute;
    inset: 0;
    animation: fadeIn 0.1s ease-in-out;
    margin: ${SPACING.p1};
    border-radius: ${DESIGN_TOKENS.borderRadius.sm};
    background-color: ${DROPZONE_BG_COLOR};
    border: 1px dashed ${DESIGN_TOKENS.border.input};
    z-index: ${GLOBAL_Z_INDEXES.fileDropzoneOverlay};

    .fileDropzoneOverlay__content {
        pointer-events: none;
    }
`

export const FileDropzoneOverlay = () => {
    return (
        <StyledFileDropzoneOverlay alignItems="center" justifyContent="center">
            <Column
                className="fileDropzoneOverlay__content"
                alignItems="center"
                justifyContent="center"
                gap="p1"
            >
                <Upload strokeWidth={1} size={SPACING.p4} />
                <Typography color="primary" variant="body2">
                    Drag and drop your file here
                </Typography>
            </Column>
        </StyledFileDropzoneOverlay>
    )
}
